// extracted by mini-css-extract-plugin
export default {"overlay":"bt-z","bodyOpen":"ct-z","content":"dt-z","header":"et-z","close":"ft-z","closeNoHeading":"gt-z"};